export default __webpack_public_path__ + "static/media/iconSearch.9cb08946.svg";